export default function () {
    this.conf.offCanvas.page.noSelector.push('#olark');
}
;



//////////////////
// WEBPACK FOOTER
// /Users/emmanuelpiguet/Documents/Web/Local/icmc/app/public/wp-content/themes/icmc/node_modules/mmenu-js/dist/wrappers/olark/mmenu.olark.js
// module id = 91
// module chunks = 0